/**
 * Support card — call/email shortcuts to the restaurant.
 */

import { MessageCircle, Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button, Card, CardContent } from '@/components/ui'

interface OrderSupportCardProps {
  phone: string | null | undefined
  email: string | null | undefined
}

export function OrderSupportCard({ phone, email }: OrderSupportCardProps) {
  const { t } = useTranslation()

  return (
    <Card className="mb-6">
      <CardContent className="py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-muted flex items-center justify-center">
              <MessageCircle className="h-5 w-5 text-muted-foreground" />
            </div>
            <div>
              <div className="font-medium">{t('common:needHelp')}</div>
              <div className="text-sm text-muted-foreground">
                {t('common:contactUsForSupport')}
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            {phone && (
              <Button
                variant="outline"
                size="sm"
                className="gap-2"
                onClick={() => window.open(`tel:${phone}`, '_self')}
              >
                <Phone className="h-4 w-4" />
                {t('common:call')}
              </Button>
            )}
            {email && (
              <Button
                variant="outline"
                size="sm"
                className="gap-2"
                onClick={() => window.open(`mailto:${email}`)}
              >
                <MessageCircle className="h-4 w-4" />
                {t('common:email')}
              </Button>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
